export default class ResetPasswordService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  changePassword(credentials) {
    return this.$http.post('/api/account/password_reset', credentials);
  }
}



// WEBPACK FOOTER //
// ./components/auth/reset-password/reset-password.service.js